export const CARD_PARTS = [
  'certification',
  'datasources',
  'domoapp',
  'drillPathURNs',
  'dateInfo',
  'metadata',
  'shareRecord',
];

export const CARD_SETTINGS = {
  CHART_PICKER: 'picker',
  DRILL: 'drill',
  EXPORT: 'data_export',
  FILTER: 'filter',
  SUMMARY: 'summary',
  TABLE: 'table',
  TITLE: 'title',
};

export const CERTIFICATION_STATES = ['CERTIFIED', 'EXPIRED', 'PENDING'];
